(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countryselectionpopup"]) return;
  try {
    
jQuery(document).ready(function() {
    function setVisited() {
        sessionStorage.setItem('hasVisitedNew', JSON.stringify({ timestamp: new Date().getTime() }));
    }

    function getVisited() {
        return JSON.parse(sessionStorage.getItem("hasVisitedNew"));
    }

    function isNewVisitor() {
        return !getVisited();
    }

    function getChosenSite() {
        return JSON.parse(localStorage.getItem("ChosenSiteNew"));
    }

    function getRememberMe() {
        return JSON.parse(localStorage.getItem("rememberme"));
    }

    function redirectToSelectedSite(link) {
        const paramsHash = window.location.hash;
        window.location.href = link + jQuery("#current_site_path").val() + '?hide_popup=true' + (paramsHash || '');
    }

    function handleCountrySelection() {
        let selectedSite = jQuery("#pop_country li.selected").data("link");
        if (selectedSite && selectedSite !== jQuery("#current_site_country").val()) {
            let obj = { link: selectedSite, value: jQuery("#current_site_country").val() };
            localStorage.setItem("ChosenSiteNew", JSON.stringify(obj));
            redirectToSelectedSite(selectedSite);
        }
    }

    // **新增：检查是否是 blogs 页面**
    const isLookbookPage = window.location.pathname.includes("blogs");                      

    if (isLookbookPage) {
        jQuery('#prod_popup').hide();
        sessionStorage.setItem('temp_redirection_stop', true);
        return; // 直接返回，不执行后续代码
    }

    // 处理新访问者和跳转
    const urlParams = new URLSearchParams(window.location.search);
    let hidePopup = !urlParams.has('hide_popup');
    let redirection = !urlParams.has('no_redirection');

    if (getChosenSite() && getRememberMe()) {
        jQuery('#prod_popup').hide();
        if (redirection && sessionStorage && !sessionStorage.getItem('temp_redirection_stop')) {
            redirectToSelectedSite(getChosenSite().link);
        }
    } else if (isNewVisitor() && !getRememberMe() && hidePopup) {
        jQuery('#prod_popup').show();
    } else {
        jQuery('#prod_popup').hide();
    }

    setVisited();

    // 绑定交互事件
    jQuery(".popup-select-lable").on("click", function() {
        jQuery("#pop_country").slideToggle();
    });

    jQuery("#pop_country li").on("click", function() {
        jQuery(".popup-select-lable").text(jQuery(this).text());
        jQuery("#pop_country li").removeClass('selected');
        jQuery(this).addClass('selected');
        jQuery("#pop_country").hide();
    });

    jQuery(document).on("click touchstart", function(e) {
        if (!jQuery(e.target).closest('#pop_country, .popup-select-lable').length) {
            jQuery("#pop_country").hide();
        }
    });

    jQuery("#pop_country_button_dorem").on("click", function(e) {
        e.preventDefault();
        jQuery('#prod_popup').hide();
        localStorage.setItem("rememberme", JSON.stringify({ currentsite: 'true' }));
        handleCountrySelection();
    });

    jQuery("#pop_country_button_dontrem").on("click", function(e) {
        e.preventDefault();
        jQuery('#prod_popup').hide();
        handleCountrySelection();
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newpopuptest"]) return;
  try {
    
	var modal = document.getElementById("prod_popup");
	    var btn = document.getElementsByClassName("popup_prod_view");
	    var span = document.getElementsByClassName("prod_popup_close")[0];
	    btn.onclick = function() {
	      modal.style.display = "block";
	    }
	    
var getip;
jQuery.get("https://ipinfo.io/json", function(response) {
    getip = response.ip;
	var geturl_data= "https://ipapi.co/"+getip+"/json/";

	jQuery.getJSON(geturl_data, function(data){


      if(data.country == 'AU'){
		
		jQuery("#pop_country option[value='Australia']").attr("selected",true);
      } else if(data.country == 'NZ'){
		
		jQuery("#pop_country option[value='New Zealand']").attr("selected",true);
      } else {
          if(data.continent_code == 'NA'){
	
			jQuery("#pop_country option[value='North America']").attr("selected",true);
          } else if(data.continent_code == 'EU'){
			
			jQuery("#pop_country option[value='Europe']").attr("selected",true);
          } else {
			
			jQuery("#pop_country option[value='Rest of World']").attr("selected",true);
          }
      }
    });
  
}, "jsonp");

jQuery(document).ready(function(e){

	var redirection = true;
	var hide_pop = true;
	const params = new URLSearchParams(window.location.search);
	
	

      for (param of params) {
        if(param[0] == 'hide_popup'){
          jQuery('#prod_popup').hide();
			hide_pop = false;
        } 
		if(param[0] == 'no_redirection'){
          redirection = false;
        } 
      }
	
	function setVisited() {

    let obj = {
      timestamp: new Date().getTime()
    }

    localStorage.setItem(
      "hasVisitedNew", 
      JSON.stringify(obj)
    );
  }

  function getVisited() {
    return JSON.parse(localStorage.getItem("hasVisitedNew"));
  }

  function isNewVisitor() {
    let timeNow = new Date().getTime();


    if (!getVisited()) {
      return true;
    } else {
      return false;
    }
  }

  if (isNewVisitor()) {
	//alert("New visitor");
	if (hide_pop) {
      jQuery('#prod_popup').show();
	}
  } else {
	//alert("not new visitor");
    jQuery('#prod_popup').hide();
	if(!jQuery.isEmptyObject(getChossenSite()) && redirection && sessionStorage && !sessionStorage.getItem('temp_redirection_stop')){
		var params_hash = window.location.hash;
		if(params_hash && params_hash == "#impact"){
			window.location.href = getChossenSite().link+jQuery("#current_site_path").val()+'?hide_popup=true'+params_hash;
		} else{
			window.location.href = getChossenSite().link+jQuery("#current_site_path").val()+'?hide_popup=true';
		}
	} else {
		if(sessionStorage && !sessionStorage.getItem('temp_redirection_stop')){
            sessionStorage.setItem('temp_redirection_stop', true);
        }
	}
  }
  setVisited();
});

function getChossenSite() {
    return JSON.parse(localStorage.getItem("ChossenSiteNew"));
}


jQuery("#pop_country_button").on("click",function(e){
    e.preventDefault();
	jQuery('#prod_popup').hide();

    
	if(jQuery( "#pop_country option:selected" ).attr("data-link") != jQuery("#current_site_country").val()){

		let obj1 = {
          link : jQuery( "#pop_country option:selected" ).attr("data-link"),
		  value : jQuery("#current_site_country").val()
        }
        localStorage.setItem(
          "ChossenSiteNew", 
          JSON.stringify(obj1)
        );

		var params_hash = window.location.hash;
		if(params_hash && params_hash == "#impact"){
			window.location.href = jQuery( "#pop_country option:selected" ).attr("data-link")+jQuery("#current_site_path").val()+'?hide_popup=true'+params_hash;
		} else {
			window.location.href = jQuery( "#pop_country option:selected" ).attr("data-link")+jQuery("#current_site_path").val()+'?hide_popup=true';
        }
    }
});




  } catch(e) { console.error(e); }
})();
})();
